import Vue from 'vue'

import Router from 'vue-router'

import index from '@/views/index'

import pageIndex from '@/views/pages/index/index'
import prolist from '@/views/pages/shop/prolist'
import brandlist from '@/views/pages/shop/brandlist'
import shopDetails from '@/views/pages/shop/shopDetails'

import customer_phone from '@/views/restaurant/customer_phone/customer_phone'



Vue.use(Router)

export default new Router({
  routes: [{
    path: '/',
    name: 'index',
    component: index,
    children: [{
      path: '/',
      name: 'pageIndex',
      component: pageIndex,
    }, {
      path: '/pages/shop/prolist',
      name: 'pages/shop/prolist',
      component: prolist,
    }, {
      path: '/pages/shop/brandlist',
      name: 'pages/shop/brandlist',
      component: brandlist,
    }, {
      path: '/pages/shop/shopDetails',
      name: 'pages/shop/shopDetails',
      component: shopDetails,
    }, {
      path: '/restaurant/customer_phone/customer_phone',
      name: 'restaurant/customer_phone/customer_phone',
      component: customer_phone,
    }]
  }],
  // return 期望滚动到哪个的位置
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      // vue2.0  x  y  控制
      // vue3.0  left  top 控制
      return {
        x: 0,
        y: 0
      }
    }
  },
})


// WEBPACK FOOTER //
// ./src/router/index.js